export default {"src":"/_next/static/media/alert-dark.44981a5e.svg","height":100,"width":100};